@if (showOnboarding) {
  <div class="onboarding-overlay" [@fadeIn]>
    <div class="onboarding-modal">
      @if (isLoading) {
        <div class="loading">
          <div class="loading-circle"></div>
        </div>
      }
      @if (!isLoading) {
        <div class="slide-content">
          <!-- <h2>{{ slides?.[currentSlide]?.title }}</h2> -->
          <!-- <p [innerHTML]="slides[currentSlide]?.content"></p> -->
          <img [src]="slides?.[currentSlide]" [alt]="slides?.[currentSlide]">
        </div>
      }
      @if (!isLoading && slides?.length > 0) {
        <div class="navigation">
          <div class="dots">
            @for (slide of slides; track slide; let i = $index) {
              <span
                [class.active]="i === currentSlide"
                (click)="goToSlide(i)">
              </span>
            }
          </div>
          <div class="buttons">
            @if (currentSlide > 0) {
              <button (click)="previousSlide()">
                {{"précédent" | translate}}
              </button>
            }
            @if (currentSlide < slides?.length - 1) {
              <button (click)="nextSlide()">
                {{"suivant" | translate}}
              </button>
            }
            @if (currentSlide === slides?.length - 1) {
              <button (click)="finishOnboarding()">
                {{"terminer" | translate}}
              </button>
            }
          </div>
        </div>
      }
    </div>
  </div>
}
